// Hermes — mergeChildResults: the deterministic fan-out merge formatter.
//
// PURE by contract: no LLM, no timestamps, no randomness — the parent's final
// `result` must be reproducible from the children alone. The fan-out driver
// calls this after every child is terminal (the domain's merge invariant).
//
//   children — child run records, ordered by childIndex
//   results  — per-child { ok, finalText?, error?, stopReason? }, aligned by index
//
// Output (pt-BR, matching the app's voice), one section per child + summary:
//
//   ## Filho 1 — <task (first 80 chars)>
//   [ok] | [falhou: <error|stopReason>] | [cancelado]
//   <finalText | (sem saída)>
//
//   --- N/M filhos ok

const TASK_HEADER_MAX = 80;
const NO_OUTPUT = '(sem saída)';

function statusLine(child, result) {
  if (result?.ok) return '[ok]';
  if (result?.stopReason === 'aborted' || child?.state === 'cancelled') return '[cancelado]';
  return `[falhou: ${result?.error || result?.stopReason || 'unknown'}]`;
}

export function mergeChildResults(children = [], results = []) {
  const sections = children.map((child, i) => {
    const result = results[i];
    const task = String(child?.task ?? '').slice(0, TASK_HEADER_MAX);
    const text =
      result?.finalText != null && String(result.finalText).trim() !== ''
        ? String(result.finalText)
        : NO_OUTPUT;
    return `## Filho ${i + 1} — ${task}\n${statusLine(child, result)}\n${text}`;
  });

  const okCount = results.filter((r) => r?.ok).length;
  const summary = `--- ${okCount}/${children.length} filhos ok`;
  return sections.length > 0 ? `${sections.join('\n\n')}\n\n${summary}` : summary;
}
